<template lang="pug">

    tr
        td {{ createdAt }}
        td {{ expireAt }}
        td.right.aligned

            a.ui.small.basic.icon.button(
                v-tooltip="'Hashlink in Zwischenablage kopieren'"
                v-on:click="copyUrl()"
            ): i.copy.icon

            a.ui.small.basic.icon.button(v-tooltip="'Hashlink löschen'" v-on:click="remove()")
                i.trash.icon

</template>

<script>
    import * as fecha from 'fecha'

    export default {
        name: 'product-files-thumbnail-hashlink-table-row-component',

        computed: {

            createdAt() {
                return this.date(this.hashlinkModel.createdAt)
            },

            expireAt() {
                return this.date(this.hashlinkModel.expireAt)
            },

            url() {
                const model = this.hashlinkModel
                return `${window.location.origin}/downloads/${model.file}?code=${model.code}`
            }

        },

        methods: {

            copyUrl() {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(this.url)
                        .then(() => this.$growl.success('Hashlink in Zwischenablage kopiert'))
                        .catch(() => this.$growl.error('Kopieren fehlgeschlagen'))
                } else {
                    const el = document.createElement('textarea')
                    el.value = this.url
                    el.style.position = 'fixed'
                    el.style.opacity = '0'
                    document.body.appendChild(el)
                    el.select()
                    document.execCommand('copy')
                        ? this.$growl.success('Hashlink in Zwischenablage kopiert')
                        : this.$growl.error('Kopieren fehlgeschlagen')
                    document.body.removeChild(el)
                }
            },

            date(value) {
                return fecha.format(value, 'DD.MM.YYYY HH:mm') + ' Uhr'
            },

            remove() {
                if(window.confirm("Hashlink wirklich löschen?")) {
                    this.$store.dispatch('hashlinks/remove', { model: this.hashlinkModel })
                        .then(() => this.$growl.success('Hashlink wurde gelöscht'))
                        .catch(e => this.$growl.fatal('Hashlink konnte nicht gelöscht werden', e))
                }
            }

        },

        props: {

            hashlinkModel: {
                type: Object,
                required: true,
            }

        }

    }

</script>
